import { RouteConfig } from 'vue-router';

import store from '@/store/store';
import { tryParseInt } from '@/utils/number';

export const documentEditGeneratedRoute: RouteConfig = {
  path: 'generate/edit/:attachmentId',
  name: 'documentEditGenerated',
  component: () =>
    import(/* webpackChunkName: "DocumentGenerate" */ '@/views/mainRoute/document/details/EditGenerated.vue'),
  meta: { breadcrumb: { title: 'Generowanie dokumentacji' } },
  beforeEnter: (to, from, next) => {
    store.dispatch('document/attachment/get', tryParseInt(to.params.attachmentId)).then(() => next());
  }
};
